import React from 'react';
import NewProjectWizardCard from './NewProjectWizardCard';
import styles from './css/index.module.css';
import checkIcon from './assets/check.svg';

const CreateProjectPreparing = ({
    items = [],
    subtitle = 'Lens is gathering organisation information and processing the project documents you provided.',
    onSkipDocuments,
    onRetryDocuments,
}) => (
    <NewProjectWizardCard title="Preparing project context" subtitle={subtitle} hideProgress hideFooter showHeaderDivider>
        <ol className={styles.preparingList}>
            {items.map(item => {
                const statusClass = item.status === 'done' ? 'Done' : item.status === 'error' ? 'Error' : item.status === 'active' ? 'Active' : 'Pending';
                return (
                    <li key={item.key} className={`${styles.preparingItem} ${styles[`preparingItem${statusClass}`]}`}>
                        <span className={`${styles.preparingIcon} ${styles[`preparingIcon${statusClass}`]}`} aria-hidden="true">
                            {item.status === 'done' ? (
                                <img src={checkIcon} alt="" width={10} height={8} className={styles.preparingCheck} />
                            ) : null}
                            {item.status === 'active' || item.status === 'error' ? <span className={styles.preparingDot} /> : null}
                        </span>
                        <div className={styles.preparingCopy}>
                            <span className={styles.preparingLabel}>{item.label}</span>
                            {item.detail ? <p className={styles.preparingDetail}>{item.detail}</p> : null}
                            {item.status === 'active' && item.longRunning ? (
                                <div className={styles.preparingExtras}>
                                    <p className={styles.preparingHelper}>Large project documents may take a little longer to process.</p>
                                    <button type="button" className={styles.preparingSkip} onClick={onSkipDocuments}>
                                        Continue without document context →
                                    </button>
                                    <p className={styles.preparingHelper}>
                                        Lens will continue processing your documents in the background. They will be used in later
                                        recommendations once ready.
                                    </p>
                                </div>
                            ) : null}
                            {item.status === 'error' ? (
                                <div className={styles.preparingErrorActions}>
                                    <button type="button" className={styles.preparingSkip} onClick={onRetryDocuments}>
                                        Retry
                                    </button>
                                    <button type="button" className={styles.preparingSkipMuted} onClick={onSkipDocuments}>
                                        Continue without document context →
                                    </button>
                                </div>
                            ) : null}
                        </div>
                    </li>
                );
            })}
        </ol>
    </NewProjectWizardCard>
);

export default CreateProjectPreparing;
